import React, { useState, useEffect, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { useDispatch } from 'react-redux';
import { isEqual } from 'lodash';
// Components
import { PaginatedList } from './PaginatedList'

// Styled
import { HorizontalStack, SmartContainer, Stack } from '../../styles/Containers'
import { StyledAreYouSure } from '../../styles/matieralui/Dialog'
import { StyledA, StyledHr, StyledP } from '../../styles/StyledHTML';
import { StyledAreYouSureButton } from '../../styles/matieralui/Button';

// Redux
import { openToast } from '../../redux/UI/ui.actions';
import { Role } from '../../redux/Auth/auth.selectors';
import { setQueryParam } from '../../services/Utils';
import { StyledIconButton } from '../../styles/matieralui/IconButton';
import { IconTrash, IconTrashClear } from '../../capturecollab/Icons';

const StyledModalList = styled(Stack)`
    ${props => (props.thinking) ? css`
         /* opacity: 1 !important;
         pointer-events: all; */
         transition: 500ms all;
      ` : ''}
    /* [data-modellist-pag-controls] { margin-bottom: 0px !important; } */

`
export const StyledMatchingMarginContainer = styled(SmartContainer)`
    border: 2px solid wheat;
`

// ----------------------------
// Model List Component
// ----------------------------

export const ModelList = ({
    model,
    defaultLimit = 8,
    defaultView = 'all',
    action,
    selector,
    onSelect,
    restore,
    customRenderer,
    variant,
    paginationControls,
    filters,
    columns,
    mobileColumns,
    forceDelete, // action
    noControls = false,
    emptyRenderer = null,
    hideSearch = false,
    infiniteScroll = false,
    prefix = 'items',
    prepend = false,
    forceLayout = false
}) => {

    const dispatch = useDispatch();
    const currentUserRole = Role();
    const [view, setView] = useState(defaultView);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(defaultLimit);
    const [searchText, setSearchText] = useState('');
    const [showAreYouSureRestore, setShowAreYouSureRestore] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [activeFilters, setActiveFilters] = useState(filters);

    const [mounted, setMounted] = useState(false);

    // Generic Selector
    const data = selector();

    const haveTheFiltersChanged = (args) => {
        let storeArgsKey = `${prefix}Args`;
        delete args.appendResults;
        if (!data[storeArgsKey]) data[storeArgsKey] = {}
        const storeArgs = { ...data[storeArgsKey] };// Clone this so we can manipulate.
        // Remove Everything That isn't A Filter.
        delete storeArgs.appendResults;
        delete storeArgs.prefix;
        delete storeArgs.page;
        delete storeArgs.limit;
        delete storeArgs.model;
        delete storeArgs.path;
        delete storeArgs.view;
        delete storeArgs.search;
        // Compare The Filters
        const argsEqual = isEqual(args, storeArgs);
        if (argsEqual === true) {
            return false;
        } else {
            return true;
        }
    }

    const appendOrReplace = (args) => {
        // Append Data but only if the filters haven't changed.
        if (infiniteScroll === true) {
            let storeArgsKey = `${prefix}Args`;
            delete args.appendResults;

            if (!data[storeArgsKey]) data[storeArgsKey] = {}
            const storeArgs = { ...data[storeArgsKey] };// Clone this so we can manipulate.
            // Remove Everything That isn't A Filter.
            delete storeArgs.appendResults;
            delete storeArgs.prefix;
            delete storeArgs.page;
            delete storeArgs.limit;
            delete storeArgs.model;
            delete storeArgs.path;
            delete storeArgs.view;
            delete storeArgs.search;

            // Compare The Filters
            const argsEqual = isEqual(args, storeArgs);
            if (argsEqual === true) {
                args.appendResults = true;
            } else {
                args.appendResults = false;
            }
        }
        return args;
    }

    let lastLoad = false;



    // Load Post With Pagination and Search
    const loadPosts = useCallback(
        (pageNumber, searchString, currentView = null, args = {}) => {

            // const adjustedFilters = appendOrReplace(args);
            // console.log(adjustedFilters, " -- AF ON LOAD")


            const clonedArgs = { ...args };
            delete clonedArgs.appendResults;
            clonedArgs.prefix = prefix;
            clonedArgs.page = pageNumber;
            clonedArgs.limit = limit;
            // clonedArgs.model = model;
            clonedArgs.search = searchString;
            clonedArgs.view = currentView;

            if (lastLoad === false) {
                // Check The Store to see if we already have this data.
                let storeArgsKey = `${prefix}Args`;
                if (data[storeArgsKey]) {
                    const inStorage = { ...data[storeArgsKey] };
                    delete inStorage.model;
                    delete inStorage.path;

                    const isSaved = isEqual(inStorage, clonedArgs);
                    if (isSaved === true) {
                        return false;
                    }
                }


            }

            // const paramsTheSame = isEqual(lastLoad, { pageNumber, limit, searchString, currentView, args: clonedArgs });
            const paramsTheSame = isEqual(lastLoad, clonedArgs)
            if (paramsTheSame !== true) {
                lastLoad = clonedArgs; // This was equal to what is above.
                return dispatch(action(pageNumber, limit, searchString, currentView, args))
            } else {

                return false;
            }
        }
        , [dispatch, action, limit])


    // --------------------------
    // Effects
    // --------------------------

    // On Load: Load posts
    // useEffect(() => { loadPosts(page,searchText) },[])

    // Set Query Params 
    useEffect(() => {
        setQueryParam('page', page)
    }, [page])

    useEffect(() => {
        setMounted(true);
    }, [])

    // End Query Params

    // Active vs Trashed
    useEffect(() => {

        setPage(1);
        setSearchText('');


        if (!filters) {

            loadPosts(1, '', view)
        } else {

            if (mounted === true) {
                const adjustedFilters = appendOrReplace(filters);
                adjustedFilters.appendResults = false; // Force this because the view has changed.
                let storeArgsKey = `${prefix}Args`;
                loadPosts(1, searchText, view, adjustedFilters)

            }
        }
        // else loadPosts(1, '', view, filters)
    }, [view, limit])

    useEffect(() => {
        setLimit(defaultLimit); // If we need to revert change the above use effect to watch deafultlimit and set the limit in the effect.
    }, [defaultLimit])


    // Apply External Filters
    useEffect(() => {


        if (!filters) return;
        // Load Items with filters applied
        const theFiltersHaveCHanged = haveTheFiltersChanged(filters);
        const adjustedFilters = appendOrReplace(filters);
        let storeArgsKey = `${prefix}Args`;

        // Working Example loading from State
        // if (adjustedFilters.appendResults !== true) {
        if (theFiltersHaveCHanged) {
            setPage(1);
            loadPosts(1, searchText, view, adjustedFilters)
        } else {
            // TODO: Bring this back and load data from the store instead of querying for it again.
            // Set The Page
            const lastPage = (data[storeArgsKey]?.page) ? data[storeArgsKey].page : 1;
            setPage(lastPage);
        }
        // END Working Example Loading From State

    }, [filters, view]) // searchText add searchText to do live type reloads

    // Restore
    useEffect(() => {
        if (data.restoreSuccess) {

            // Display Success
            dispatch(openToast(data.restoreSuccess, 'success'));

            // Reload Active.
            setView('all');
        }
        if (data.restoreError) dispatch(openToast(data.restoreError, 'error'))
    }, [data.restoreLoading, data.restoreSuccess, data.restoreError, dispatch])

    // Force Delete
    useEffect(() => {

        if (data.forceDeleteSuccess) {

            // Display Success
            dispatch(openToast(data.forceDeleteSuccess, 'success'));

            // Reload Active.
            setView('all');
        }
        if (data.forceDeleteError) dispatch(openToast(data.forceDeleteError, 'error'))
    }, [data.forceDeleteLoading, data.forceDeleteSuccess, data.forceDeleteError, dispatch])




    // --------------------------
    // Interactions
    // --------------------------

    // Handle Item Click
    const handleItemClick = (item) => {

        if (view === 'trashed') {
            setShowAreYouSureRestore(true);
            setSelectedItem(item);
            return;
        }

        onSelect(item);
    }

    // Handle Pagination Click
    const handlePaginationClick = (pageNumber) => {
        setPage(pageNumber)
        // CAPTURE COLLAB OVERRIDE
        // loadPosts(pageNumber, searchText)
        const adjustedFilters = appendOrReplace(filters);
        loadPosts(pageNumber, searchText, view, adjustedFilters)
        // END CAPTRUE COLLAB CHANGE
    }

    // Handle Search
    const handleSearch = (searchString) => {
        setPage(1)
        loadPosts(1, searchText)
    }

    const onAreYouSureRestore = (e) => {
        if (!e) setShowAreYouSureRestore(false)
        else {
            setShowAreYouSureRestore(false)
            dispatch(restore(selectedItem.id));
        }
    }

    const handleForceDelete = (e) => {
        setShowAreYouSureRestore(false)
        dispatch(forceDelete(selectedItem.id));
    }

    // --------------------------
    // Pagination Formating
    // --------------------------

    const formatted = (data.items) ? data.items.rows.map(item => { return { id: item.id, title: item.name, description: item.status, full: item } }) : []
    const total = (data.items) ? data?.items?.count : 0;
    const pageCount = Math.ceil(total / limit);


    const renderView = () => {
        if (noControls) return;
        // Capture Collab - Only Show View is you are an admin.
        if (currentUserRole !== 'owner' && currentUserRole !== 'admin') return null;

        // if (infiniteScroll) return null; // Don't show transhed on infinite Scroll.

        if (defaultView !== 'all') return null;
        if (view === 'all') return (<StyledA small light onClick={() => setView('trashed')}>View Trashed</StyledA>)
        return (<StyledA small light onClick={() => setView('all')}>View All</StyledA>)
        // if (view === 'all') return (<StyledIconButton onClick={() => setView('trashed')}><IconTrash /></StyledIconButton>)
        // return (<StyledIconButton onClick={() => setView('all')}><IconTrashClear /></StyledIconButton>)
    }

    const renderEmpty = () => {
        if (!data?.itemsLoading && !data?.restoreLoading && !data?.forceDeleteLoading && total === 0 && emptyRenderer) {

            if (view === 'all') {
                return (
                    <SmartContainer>{emptyRenderer()}</SmartContainer>
                )
            } else {
                return (
                    <SmartContainer flex align="center" justify="center">
                        <StyledP light>The trash is empty.</StyledP>
                    </SmartContainer>
                )
            }
        }
        return null;
    }

    const renderPaginationControls = () => {
        return (
            <HorizontalStack data-modellist-pag-controls width="100%" flex align="center" justify="flex-end">

                {paginationControls && paginationControls()}
                {renderView()}
            </HorizontalStack>
        )
    }

    return (
        <StyledModalList thinking={data?.itemsLoading || data?.restoreLoading || data?.forceDeleteLoading} variant={variant}>



            <br />

            <PaginatedList
                onClickItem={handleItemClick}
                loading={data?.itemsLoading || data?.restoreLoading}
                items={formatted}
                total={total}
                pages={pageCount}
                currentPage={page}
                onPaginationClick={handlePaginationClick}
                searchText={searchText}
                onSearchChange={(value) => setSearchText(value)}
                onSearchSubmit={handleSearch}
                customRenderer={customRenderer}
                variant={variant}
                paginationControls={paginationControls}
                columns={columns}
                mobileColumns={mobileColumns}
                noControls={noControls}
                hideSearch={hideSearch}
                emptyRenderer={renderEmpty}
                infiniteScroll={infiniteScroll}
                prepend={prepend}
                forceLayout={forceLayout}

            />
            <SmartContainer flex>{renderView()}</SmartContainer>

            {/* {renderEmpty()} */}

            <StyledAreYouSure
                loading={false}
                open={showAreYouSureRestore}
                onClose={onAreYouSureRestore}
                label="Are you sure?"
                description="This will restore this item."
                agreeText="Yes, restore this."
            >
                {forceDelete && (
                    <Stack>
                        <StyledHr />
                        <StyledAreYouSureButton variant="outlined" width="100%" onClick={handleForceDelete}>Delete Permenantly</StyledAreYouSureButton>
                    </Stack>

                )}
            </StyledAreYouSure>

        </StyledModalList>
    )
}